"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHtmlElement = isHtmlElement;

function isHtmlElement(el) {
  return !!el && 'dataset' in el;
}